export const LocationAdjectivesOne = [
    'Very',
    'Dark',
    'Infested',
    'Corrupted',
    'Bright',
    'Slightly',
    'Barely',
    'A Tad Bit'
]
export const LocationAdjectivesTwo = [
    'Mysterious',
    'Evil',
    'Fun',
    'Creative',
    'Creepy',
    'Satanic',
    'Haunted',
    "After Midnight"
]

export const MonsterAdjectives = [
    'Weak',
    'Strong',
    'Undead',
    'Powerful',
    'Trained',
    'Intern',
    'Cruel',
    'Sophisticated',
    'Edgy',
    'JavaScript learning',
    'Big and Tall',
    'UwU',
    'Uneducated',
    'Gamer',
    'Street',
    'Sea',
    'Landbased',
    'Sporty',
    'Politically Correct',
    'Strange'
]

export enum MonsterNames {
    SLIME = 'Slime',
    BATS = 'Bats',
    SKELETON_HORSE = 'Skeleton Horse',
    DRAGON = 'Dragon',
    WEREWOLF = 'Werewolf',
    CRABBO = 'Crabbo With a Stabbo',
    SKULL = 'Yorick',
    BANDIT = 'Friend of The Stranger',
    MINUTAUR = 'Minotaur',
    HYDRA = 'Hydra',
    ICE_HYDRA = 'Ice Hydra',
    MIND_FLAYER = 'Stranger Flayer',
    GOBLIN_STACK = 'Two Goblins in a Trench coat'
}

export enum ClassNames {
    ARCHER = 'Archer',
    KNIGHT = 'Knight',
    WIZARD = 'Wizard',
    BOXER = 'Boxer'
}

export enum SpriteGenderNames {
    M = 'm',
    F = 'f',
}

export enum LocationNames {
    FOREST = 'Forest',
    DUNGEON = 'Dungeon'
}